<template>
  <v-container :key="reloadKey">
    <HandleImportError
      :dialog="dialog"
      :errorMode="errorMode"
      :errors="errors"
      :showDependencyBtn="showDependencyBtn"
      @openCloseDialog="openCloseDialog"
      @getAdditionalImportedData="getAdditionalImportedData"
    />
    <v-row class="mt-0 pt-0">
      <v-col cols="6">
        <v-file-input :disabled="!pipeline"
        v-model="file"
        :accept="acceptedFormats"
        :label="'Import ' + acceptedFormats"
        show-size
        :rules="checkSize"
        clearable
        class="input-text-size" />
      </v-col>
      <v-col cols="6">
        <v-switch
          class="input-text-size"
          id="tmc-transform-import-isBackupNeeded"
          hide-details
          color="warning"
          v-model="isBackupNeeded"
          :label="isBackupNeeded ? 'Backup OFF' : 'Backup ON'" />
      </v-col>
    </v-row>
    <div class="d-flex align-center justify-space-around flex-row
        taxroll-table-wrapper-two">
      <v-btn class="input-text-size" text color="blue darken-1"
       @click="importFile" :disabled="disableButtons">
        {{ dynamicNameForImport }}
      </v-btn>
      <v-btn class="input-text-size" text color="blue darken-1" @click="viewFile">
        View File
      </v-btn>
    </div>
    <v-row v-if="importing">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <p class="input-text-size">{{statusText}}</p>
          <v-progress-linear
          color="deep-purple accent-4"
          :value="progress"
          rounded
          height="5"
          ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-if="reload">
      <v-col cols="12">
        <v-btn class="input-text-size" rounded
          id="tmc-btn-import-state-reload-beta" @click="reloadMe">
          <v-icon class="mr-2">{{icons.mdiReload}}</v-icon> Load another
        </v-btn>
      </v-col>
      <v-col cols="12">
        <a v-if="hasReportTemplate"
          class="input-text-size"
          :href="dynamicReportUrl()"
          target="_blank">Open the report</a>
      </v-col>
      <v-col cols="12">
        <span class="input-text-size" v-if="showImportTimmings">Imported in: {{this.timing}}</span>
      </v-col>
    </v-row>
    <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey"
  dialogDynamicWidth="100vw"
  :canSave="false">
    <template v-slot:[`editedItem`]="{ }">
      <v-textarea id="edited-item-remarks"
          class="war-trans-item-remarks"
          rows="10"
          :value="dataFromImport"
          ></v-textarea>
    </template>
      </CRUDDialog>
  </v-container>
</template>

<script>
import {
  mdiReload,
} from '@mdi/js';
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { clients } from '../../../util/clients';
import {
  dateDiffStr,
} from '../../../util/shared/tmc-global';
import {
  amountToNumber,
  sanitizeFilename,
} from '../../../util/shared/vue-global';
import {
  generateReportUrl,
  generateChunckID,
  getImportRedirectionUrl,
} from '../../config/TransformMapper.util';
import HandleImportError from '../../../views/bulk/HandleImportError.vue';
import { filePreValidate, importFileProgramMapperWithBackup } from '../../../views/bulk/import.utils';
// import { filePreValidate, importFileProgramMapperWithBackup } from './import.utils';
import CRUDDialog from '../base/crud-2.0/CRUDDialog.vue';
import '../../../assets/style.css';
import { folderNameForUploadToBackend } from '../../tax/common-utils/tax-common.util';

const { backendRest } = clients.direct;

// Files pulled off the Landmark FTP are expanded into ASSESSOR_UNZIPPED_DIR
// ('/data/assessor-unziped-files') on the backend, and uploadFileToDB resolves
// its data dir as `/data/${folderName}`.

const initdata = () => ({
  form: new FormData(),
  dialog: false,
  errorMode: undefined,
  icons: {
    mdiReload,
  },
  file: undefined,
  importing: false,
  reload: false,
  reloadKey: 0,
  statusText: '',
  progress: 0,
  timing: undefined,
  errors: [],
  chunkID: '',
  additionalImportedData: {},
  programSelect: undefined,
  baseCrudKey: 'commonImportShowFile',
  dataFromImport: null,
  disableButtons: false,
  statusPolling: null,
  isBackupNeeded: false,
});

export default {
  name: 'AssessorUpdateImportFiles',
  components: {
    HandleImportError,
    CRUDDialog,
  },
  data: () => initdata(),
  props: {
    acceptedFormats: {
      type: String,
      default: '.txt,.csv,.prn',
    },
    profileName: {
      type: String,
      default: '',
    },
    dynamicNameForImport: {
      type: String,
      default: 'Import',
    },
    selectedFileName: {
      type: String,
      default: '',
    },
    assessorSelectedFile: {
      type: String,
      default: '',
    },
    dynamicUpdateInputs: {
      type: Object,
      default: () => {},
    },
    showImportTimmings: {
      type: Boolean,
      default: true,
    },
    makeBackupToTrue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      warSettingItem: (state) => state.SystemConfig.warSettingItem,
      pipeline: (state) => state.tax.MortgageCoProcessing.pipeline,
    }),
    showDependencyBtn() {
      return (this.pipeline || {}).createDependency || false;
    },
    checkSize() {
      return [
        (value) => {
          if (value && value.size > 30000000) {
            this.disableButtons = true;
            return 'File size should be less than 30 MB';
          }
          this.disableButtons = false;
          return true;
        },
      ];
    },
  },
  created() {
    this.loadConfig({ requiredScope: 'warconfig' });
    this.loadConfig({ requiredScope: 'global' });
  },
  mounted() {
    this.isBackupNeeded = this.makeBackupToTrue;
  },
  beforeDestroy() {
    if (this.statusPolling) clearInterval(this.statusPolling);
  },
  methods: {
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('jobs', [
      'backup',
    ]),
    ...mapMutations('jobs', [
      'setPrefix',
      'setGroup',
      'setCollection',
    ]),
    ...mapActions([
      'flashError',
      'flashInfo',
      'flashSuccess',
    ]),
    ...mapActions('tax/commonImport', [
      'uploadFileToDB',
      'pollingToGetBackgroundProcess',
    ]),
    ...mapMutations('base/crud', [
      'setIsVisible',
    ]),
    handleDialog() {
      this.setIsVisible([this.baseCrudKey, true]);
    },
    getAdditionalImportedData(val) {
      this.additionalImportedData = { ...val };
    },
    openCloseDialog(value) {
      this.dialog = value;
    },
    // async onFileSelected(file) {
    //   console.info(file);
    //   if (file) {
    //     await this.importFile(file);
    //   }
    // },
    async insertUploadedFile(form) {
      this.importing = true;
      try {
        form.append('preValidate', false);
        const formHeaders = {
          'Content-Type': 'multipart/form-data',
        };
        const results = await backendRest.post('/transmap/import', form, {
          headers: formHeaders,
          onUploadProgress: (progEvt) => {
            console.info('upload');
            try {
              const percentComplete = (progEvt.loaded / progEvt.total) * 100;
              this.statusText = `${percentComplete}% of file uploaded...`;
              this.progress = percentComplete;
            } catch {
              // do nothing
            }
          },
          onDownloadProgress: (progEvt) => {
            console.info('download');
            try {
              const kbRecvd = progEvt.loaded / 1024;
              this.statusText = `Getting import progress (${amountToNumber(kbRecvd)} kb)...`;
              this.progress = kbRecvd;
            } catch {
              // do nothing
            }
          },
        });
        this.importing = false;
        this.statusText = '';
        this.file = undefined;

        const startDt = this.timing;
        const endDt = new Date();
        this.timing = dateDiffStr(startDt, endDt);

        this.reload = true;
        if (!results || !results.data || results.data.ok !== 1) {
          this.flashError('Unable to upload file.');
          return false;
        }
        this.$emit('loadCRUDList');
        this.flashSuccess('Imported!');

        this.form = new FormData();
        if (!(this.errors == null) && this.errors.length > 0) {
          this.$router.push({
            name: 'Auto Created Dependencies',
            params: {
              args: this.errors,
              redirectToPage: {
                url: this.dynamicReportUrl(),
                params: this.chunkID,
              },
            },
          });
        }
        // else {
        //   this.openIfReportTemplate();
        // }
        return true;
      } catch (err) {
        console.error('Error while upserting imported file', err);
      }
      return true;
    },
    // The FTP file already lives on the backend, so nothing is uploaded from the
    // browser here - the import is kicked off server-side and polled for status.
    importFtpFile() {
      const criteria = {
        folderName: folderNameForUploadToBackend.assessorUnzippedFolder,
        profileName: this.assessorSelectedFile,
        fileName: this.selectedFileName,
        additionalInputs: {
          assessorIgnoreTaxPaidFlag: (this.dynamicUpdateInputs || {}).value || 1,
        },
      };
      this.importInBackend(criteria);
    },
    importInBackend(criteria = {}) {
      const loadTaxPromise = this.uploadFileToDB(criteria);
      this.importing = true;
      this.timing = new Date();
      loadTaxPromise.then(() => {
        this.startTheCounter(criteria.folderName);
      });
    },
    startTheCounter(folderName) {
      this.statusPolling = setInterval(() => {
        this.callThePollingFunc(folderName);
      }, 2200);
    },
    callThePollingFunc(folderName) {
      const loadPromise = this.pollingToGetBackgroundProcess({ folderName });
      loadPromise.then((res) => {
        this.statusText = `Currently imported ${res && (res.count || 0)} records`;
        if (res.status === 'File imported!') {
          this.flashSuccess(res.status);
          this.stopTheCounter();
          this.timing = dateDiffStr(this.timing, new Date());
          this.reload = true;
          this.$emit('loadCRUDList');
        } else if (res.status === '') {
          this.stopTheCounter();
          this.$emit('loadCRUDList');
        } else if (res.status !== 'Starting the import process' && res.status !== 'importing file to DB') {
          this.stopTheCounter();
        }
      }).catch((err) => {
        console.error('--------error', err);
        this.stopTheCounter();
      });
    },
    stopTheCounter() {
      this.importing = false;
      this.statusText = '';
      clearInterval(this.statusPolling);
      this.statusPolling = null;
    },
    viewFile() {
      const { file } = this;
      if (file) {
        const bytesVal = 1000000; // its equal to 1mb
        const chunkSize = 2000;
        const fileSize = (file.size > bytesVal) ? bytesVal : file.size;
        const dataVal = [];
        for (let i = 0; i < fileSize; i += chunkSize) {
          // eslint-disable-next-line func-names
          (function (fil, start) {
            const reader = new FileReader();
            const blob = fil.slice(start, chunkSize + start);
            reader.readAsText(blob);
            reader.addEventListener(
              'load',
              () => {
                dataVal.push(reader.result);
              },
              false,
            );
          }(file, i));
        }
        this.dataFromImport = dataVal;
        this.handleDialog();
      }
    },
    async takeDbBackup() {
      this.importing = true;
      this.statusText = 'Loading file...';
      let successfulBackup = false;
      if (window.confirm('Would you like to take a backup before bulk changes?')) {
        this.setGroup('tmc-local-backend');
        this.setPrefix(`importfilesprebackup_${this.pipeline.program}`);
        const collection = importFileProgramMapperWithBackup[this.pipeline.program];
        // if mapper will not match with any program, it will get 'undefined'
        this.setCollection(collection);
        successfulBackup = await this.backup();
      }
      if (!successfulBackup) {
        this.importing = false;
        this.statusText = '';
        this.file = null;
      }
      return successfulBackup;
    },
    async importFile() {
      const { file } = this;
      if (!this.assessorSelectedFile) {
        this.flashInfo('Please select Assessor Profile');
        return false;
      }
      // a file picked from the FTP list is already sitting on the backend, so it
      // is imported there rather than being uploaded from the browser
      if (this.selectedFileName) {
        this.importFtpFile();
        return true;
      }

      if (file) {
        try {
          this.timing = new Date();

          // backup the db
          if (!this.isBackupNeeded) {
            const successfulBackup = await this.takeDbBackup();
            // if backup failed, return
            if (!successfulBackup) return false;
          } // if backup is not needed, continue

          this.disableButtons = true;
          let objCheckDataExits = {};
          if (this.dynamicUpdateInputs && Object.keys(this.dynamicUpdateInputs).length) {
            objCheckDataExits = this.dynamicUpdateInputs;
          }
          let inputsStr = this.pipeline.inputs;
          let profileNameNotExits = {};
          if (this.profileName !== '') profileNameNotExits = { type: 'constant', prop: 'profileName', value: this.profileName };
          const clubbedObj = { ...profileNameNotExits, ...objCheckDataExits };
          // if dynamic update inputs is not empty, then add the clubbedObj to the inputs
          if (this.dynamicUpdateInputs && Object.keys(this.dynamicUpdateInputs).length) {
            inputsStr = JSON.stringify([clubbedObj]);
          } else {
            inputsStr = JSON.stringify([]);
          }

          // import the file
          const form = new FormData();
          form.append('fileName', sanitizeFilename(file.name));
          form.append('transMapName', this.pipeline.name);
          form.append('inputs', inputsStr);
          form.append('data', file);
          form.append('preValidate', true);
          this.chunkID = generateChunckID({ profileName: this.pipeline.name });
          form.append('chunkID', this.chunkID);
          form.append('profileID', this.pipeline._id);
          form.append('batchSize', this.pipeline.batchSize);

          const formHeaders = {
            'Content-Type': 'multipart/form-data',
          };
          [this.dialog, this.errors, this.errorMode] = await filePreValidate({ form, formHeaders });
          if (this.dialog) {
            this.form = form;
            return false;
          }

          this.insertUploadedFile(form);
          this.disableButtons = false;
          return true;
        } catch (err) {
          this.disableButtons = false;
          console.error(err);
          this.flashError('There was a problem while importing your file.');
          return false;
        }
      }
      return false;
    },
    dynamicReportUrl() {
      const programWiseSettings = {
        warSettings: this.warSettingItem,
      };
      const redirectionUrl = getImportRedirectionUrl(this.pipeline,
        this.programSelect, programWiseSettings);
      const parsedInputs = JSON.parse(this.pipeline.inputs || '[]');
      const route = generateReportUrl(
        redirectionUrl,
        parsedInputs,
        {
          chunkID: this.chunkID,
          program: this.pipeline.program,
        },
      );
      return route;
    },
    hasReportTemplate() {
      return (this.pipeline.reportTemplate || '').length > 0;
    },
    // openIfReportTemplate() {
    // if (this.hasReportTemplate()) {
    //   const toUrl = this.dynamicReportUrl();
    //   window.open(toUrl, '_blank');
    // }
    // },
    reloadMe() {
      Object.assign(this.$data, initdata());
      this.reloadKey += 1;
    },
  },
  watch: {
    makeBackupToTrue(val) {
      this.isBackupNeeded = val;
    },
  },
};
</script>
